module.exports = __webpack_public_path__ + "static/media/YF91_3.b64d56d8.jpg";